import request from 'services/request'
import _get from 'lodash/get'

export function handleSignatureTokenResponse (res, _dataError) {
  const data = _get(res, 'body', {})
  return {
    _dataError: _dataError || null,
    signature: _get(data, 'signature', null),
    token: _get(data, 'token', null),
    tenantId: _get(data, 'tenantId', null),
    key: _get(data, 'key', null),
    success: _get(data, 'success', false),
  }
}

/**
 * Brooklyn request to get the Zuora rsa signature and token in order to render the payment iframe.
 * @param {Object} [options={}] The options
 * @param {String} options.pageId The page id for the desired Zuora iframe
 * @param {String} options.uri The uri for the Zuora iframe
 * @param {String} options.server The server to make the api call to
 */
export async function getZuoraIframeSignatureToken (options = {}) {
  const { pageId, uri, server } = options

  try {
    const res = await request
      .post(`${server}/v1/billing/iframe-init`)
      .set('accept', 'application/json')
      .send({ uri, pageId })

    return handleSignatureTokenResponse(res)
  } catch (e) {
    return handleSignatureTokenResponse({ success: false }, true)
  }
}
